import { render, staticRenderFns } from "./perfect-price.vue?vue&type=template&id=463c5065&scoped=true&"
import script from "./perfect-price.vue?vue&type=script&lang=js&"
export * from "./perfect-price.vue?vue&type=script&lang=js&"
import style0 from "./perfect-price.vue?vue&type=style&index=0&id=463c5065&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463c5065",
  null
  
)

export default component.exports